import React from 'react';
import { Link } from 'gatsby';
import { css } from '@emotion/react';
import Image from 'gatsby-plugin-sanity-image';
import CardScroller, { cardStyles } from './card-scroller';
import { hasContent } from '../content';

export default function ArtistScroller({ className, title, artists, programs }) {
  return (
    <div
      className={className}
    >
      <div
        className="type--70"
        css={css`
          padding: 0 var(--margin);
          margin-bottom: var(--gutter);
        `}
      >
        {title}
      </div>
      <CardScroller>
        {programs?.length > 0 && programs
          .map((program, i) => (
            <Link
              key={i}
              css={cardStyles}
              to={`/program/${program.slug.current}`}
            >
              {program.featureImage?.asset && <Image
                {...program.featureImage}
                width={990}
                height={620}
                style={{
                  width: '100%',
                  marginBottom: '0.15em',
                  lineHeight: 0,
                }}
                loading="eager"
              />}
              {!program.featureImage?.asset &&
                <div
                  css={css`
                    padding-bottom: 62.5%;
                    background-color: var(--primary);
                  `}
                />
              }
              {hasContent(program.format?.map(format => format.title)) && <div
                css={css`
                  margin-bottom: 0.15em;

                  &::before {
                    content: '';
                    display: inline-block;
                    width: 1.1rem;
                    height: 1.1rem;
                    border-radius: 50%;
                    background-color: var(--black);
                    margin-right: 1rem;
                  }
                `}
              >
                {program.format.map(format => format.title).filter(hasContent).join('/\u200B')}
              </div>}
              <div
                css={css`
                  text-transform: uppercase;
                `}
              >{program.title}</div>
            </Link>
          ))
        }
        {artists.length > 0 && artists
          .map((artist, i) => (
            <Link
              key={i}
              css={cardStyles}
              to={`/artist/${artist.slug.current}`}
            >
              {artist.featureImage?.asset && <Image
                {...artist.featureImage}
                width={990}
                height={620}
                style={{
                  width: '100%',
                  marginBottom: '0.15em',
                  lineHeight: 0,
                }}
                loading="eager"
              />}
              {!artist.featureImage?.asset &&
                <div
                  css={css`
                    padding-bottom: 62.5%;
                    background-color: var(--primary);
                  `}
                />
              }
              {hasContent(artist.type) && <div
                css={css`
                  margin-bottom: 0.15em;

                  &::before {
                    content: '';
                    display: inline-block;
                    width: 1.1rem;
                    height: 1.1rem;
                    border-radius: 50%;
                    background-color: var(--black);
                    margin-right: 1rem;
                  }
                `}
              >{artist.type}</div>}
              <div
                css={css`
                  text-transform: uppercase;
                `}
              >{artist.name}</div>
            </Link>
          ))
        }
      </CardScroller>
    </div>
  )
}
